import httpClient from 'axios';
import axiosRetry from 'axios-retry';

export const configureErrorHandler = (httpClient, navigate) => {
  httpClient.interceptors.response.use(
    (response) => response,
    (error) => {
      const statusCode = error?.response?.status;
      switch (statusCode) {
        case 401:
        case 403:
          navigate.toErrorUnauthorized();
          break;
        case 405:
        case 503:
          navigate.toErrorServiceUnavailable();
          break;
        default:
          navigate.toError();
          break;
      }
    }
  );

  return httpClient;
};

export const configureApiRequestMiddleware = (httpClient, cspAccessToken) => {
  httpClient.interceptors.request.use(
    (request) => {
      const headersToBeAdded = {
        Pragma: 'no-cache',
        Expires: 'Thursday, 01 Jan 1970 00:00:00 GMT',
        'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
        'Content-Type': 'application/json',
        Authorization: cspAccessToken
      };

      Object.entries(headersToBeAdded).forEach(([key, value]) => {
        request.headers.set(key, value);
      });

      return request;
    },
    (error) => Promise.reject(error)
  );

  return httpClient;
};

export const configureRetry = (httpClient) => {
  axiosRetry(httpClient, { retries: 1 });
  return httpClient;
};

export const configureHttpClient = (authDetails) => {
  const cspAccessToken = authDetails?.cspAccessToken;
  httpClient.defaults.baseURL = process.env.CSP_MIDDLEWARE_API;
  httpClient.interceptors.request.clear();
  httpClient.interceptors.response.clear();

  httpClient.interceptors.response.use(
    (response) => response,
    (error) => error
  );

  configureApiRequestMiddleware(httpClient, cspAccessToken);
  configureRetry(httpClient);
};

export default httpClient;
